// import discountImg from "../../../../assets/images/icons/discount.png";
import { Tooltip } from 'antd';

// import RoundCountDown from "../../../../helbest/RoundCountDown/RoundCountDown";
import warantiesImg from '../../../../assets/images/icons/waranties.png';
import { BaseURL } from '../../../../base/env';
import { TComma } from '../../../../base/utils';
import { Box, Button, Uniter } from '../../../../helbest';
import styles from './ItemBox.module.css';
import Suggestion from './Suggestion/Suggestion';

const ItemBox = ({ data, add_to_cart, showModal_visible }) => (
  /**
   *
   * @param {String} title
   * check if title includes SN
   * show the discount icon
   */
  // const checkTitle = (title) => {
  //     return title.includes("SN");
  // }
  <Box className="component-product-item" id={data.tag}>
    <div>
      <div className="ws-100 mar-b-10">
        <div className="product-item-icons">
          <Tooltip title="اصالت کالا">
            <div className="product-item-icon mar-l-8">
              <img alt="waranties" height="27px" src={warantiesImg} />
            </div>
          </Tooltip>
          {/* {checkTitle(data.name) && (
                            <Tooltip title={"دارای کد تخفیف"}>
                                <div className="product-item-icon">
                                    <img alt="discount" src={discountImg} height="27px"/>
                                </div>
                            </Tooltip>
                        )} */}
        </div>
        {data.label && data.label_style !== 'none' ? (
          <Suggestion label={data.label} type={data.label_style} />
        ) : null}
      </div>
    </div>
    <div className="product-item-body">
      <div className="product-item-data">
        <span
          className="product-item-data-title mar-b-8"
          onClick={() => {
            showModal_visible();
          }}>
          {data.name}
        </span>

        <div className="product-item-data-price-container ws-100">
          {data.discount_amount ? (
            <span className="slide-off-percent">
              {data.visible_discount_type === 'fixed'
                ? TComma(data.fixed_discount_amount)
                : `%${data.discount_percentage}`}
            </span>
          ) : null}
          <div className="product-item-data-price">
            <Uniter className="" unit="تومان">
              {data.item_payable_amount}
            </Uniter>

            {data.payable_amount !== data.price ? (
              <Uniter className="product-item-data-price-discount">{data.item_price}</Uniter>
            ) : null}
          </div>
        </div>
      </div>

      <div
        className="product-item-img mar-r-20"
        onClick={() => {
          showModal_visible();
        }}>
        {/* {data.auction && (
            <>
              <div className={"spetial-pack-label"}>بسته حراجی</div>
              <div className={"spetial-pack-time-container"}>
                <RoundCountDown
                  seconds={data.seconds}
                  remains={data.remains}
                  padding={3}
                  strokeWidth={3}
                />
              </div>
            </>
          )} */}
        <img alt={data.id} loading="lazy" src={BaseURL + data.image} />
      </div>
    </div>
    <div className={styles.TextCounter}>
      {data.stock !== null ? `تنها ${data.stock} عدد در انبار باقی مانده` : ``}
    </div>

    <hr />
    <div className="product-item-footer ws-100">
      <div className="detail-buttons">
        <div className="flex">
          <Button onClick={() => add_to_cart(data)}>افزودن به سبد</Button>
          <span
            onClick={() => {
              showModal_visible();
            }}>
            <p className="mar-t-8 mar-l-5">مشاهده جزئیات</p>
            {/* <img src={IconChevronLeft} alt="<" /> */}
          </span>
        </div>
        {data.label_2 ? (
          <div className="item-quantity-in-box mar-r-8">
            {/* <p>تعداد در کارتن :</p> */}
            <span>{data.label_2}</span>
          </div>
        ) : null}
      </div>
    </div>
  </Box>
);
export default ItemBox;
